import { render, staticRenderFns } from "./spare.vue?vue&type=template&id=4378683e&scoped=true"
import script from "./spare.vue?vue&type=script&lang=js"
export * from "./spare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4378683e",
  null
  
)

export default component.exports